import { reatomAsync } from "@reatom/async";
import { API } from "src/api";
import { withIsLoadingAtom } from "src/common/pipes";
import { toastHandler } from "src/util";

const MIN_AMOUNT = 150;

export const fetchCreateBalanceOrder = reatomAsync(
  async (_ctx, amount: number) => {
    if (amount < MIN_AMOUNT)
      return toastHandler.warning({
        title: "Неверная сумма",
        name: "payment",
        content: `Минимальная сумма оплаты ${MIN_AMOUNT}₽`,
      });

    const paymentWindow = window.open("", "_blank");
    if (!paymentWindow) {
      alert("Всплывающее окно было заблокировано вашим браузером.");
      return;
    }

    await API.paymentApi
      .paymentControllerPaymentBalance()
      .then((response) => {
        paymentWindow.location.href = response.data.link;
      })
      .catch(() => {
        paymentWindow.close();
      });
  },
  "createBalanceOrder",
).pipe(withIsLoadingAtom());
